<div class="cf">
    <div>
      <div class="bluebg-blocks be-data-box">
        <div class="salesforce-mapping" *ngIf="!isFromDashboard && (_authenticationService.Admin() || _authenticationService.Broker() || _authenticationService.SuperAdmin())">
          Salesforce ID#
          <a *ngIf="property.SFId" class="bluelink sf-link" href="{{property.SFLink}}" target="_blank">{{property.SFId}}</a>
          <span *ngIf="!property.SFId">Not Mapped</span>
          <a class="blueone quick-edit margin-left-10" tooltip="Edit Salesforce mapping" href="javascript:void(0);" (click)="openModalForSF(SalesForceMapper,'panlestyle')"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
        </div>

        <h3 class="bluelabel margin-top-10 margin-bottom-10 margin-left-10" *ngIf="!(!isFromDashboard && prospectTabVisibility) && property.IsPortfolio">Portfolio</h3>
        <div class="data-lock" *ngIf="isFromPortfolio">
          <i class="fa fa-lock"></i>
        </div>
        
        <ul>
          <ng-container *ngIf="!(!isFromDashboard && prospectTabVisibility)">
            <li *ngFor="let type of externalMarketingTypeList">
              <div class="whiteblock cursor-pointor" (click)="isFromDashboard ? '' : loadExternalMarketingType(type)" [class.active]="menuId == type.id">
                <div class="be-label">
                  {{type.description}}
                  <!--<span style="background-color: rgb(236, 85, 85);"></span>-->
                </div>
                <h3 *ngIf="!isFromPortfolio" class="cursor-pointor margin-bottom-5">{{this.showNodata ? 0 : (type.count | number:0)}}</h3>
                <h3 *ngIf="isFromPortfolio" style="
                         color: transparent; text-shadow: 0 0 8px #000;" class="cursor-pointor margin-bottom-5">
                  {{this.showNodata ? 0 : (type.count | number:0)}}
                </h3>


                <a class="a-normal" *ngIf="((isFromDashboard && !prospectTabVisibility) || (isFromDashboard && prospectTabVisibility && type.id ==0 &&  property.ShowProspectToSeller)) && !isFromPortfolio" (click)="loadExternalMarketingType(type)">View Details</a>
              </div>
            </li>

          </ng-container>
        </ul>
        <a (click)="showPlusView = !showPlusView" class="d-flex" *ngIf="!(!isFromDashboard && prospectTabVisibility) && property.IsPortfolio">
          <div class="collapse-hd d-flex" [ngClass]="{'active' : showPlusView}">
            <!--<h3  class="bluelabel  mr-auto">Portfolio + View</h3>-->
            <!--<h3 *ngIf="!showPlusView" class="bluelabel  mr-auto">Portfolio + View</h3>
      <h3 *ngIf="showPlusView" class="bluelabel  mr-auto">Hide Portfolio + View</h3>-->
            <!--<i class="fa fa-angle-right" aria-hidden="true"></i>-->
            <span *ngIf="!showPlusView" class="a-link ml-auto">Property Level Marketing <i class="fa fa-angle-right margin-left-5" aria-hidden="true"></i></span>
            <span *ngIf="showPlusView" class="a-link ml-auto">Hide Details <i class="fa fa-angle-up margin-left-5" aria-hidden="true"></i></span>
          </div>
        </a>
        <div *ngIf="showPlusView" class="portfolio-view-box cf">
          <h3 class="bluelabel margin-top-10 margin-bottom-10 margin-left-10">Property Level Marketing Summary</h3>
          <ul>
            <ng-container>
              <li *ngFor="let type of externalMarketingTypeListForProperties">
                <div class="whiteblock cursor-pointor">
                  <div class="be-label">
                    {{type.description}}
                    <span style="background-color: rgb(236, 85, 85);"></span>
                  </div>
                  <h3 class="cursor-pointor margin-bottom-5">{{this.showNodata ? 0 : (type.count | number:0)}}</h3>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>

      </div>
    </div>
</div>
<ng-container *ngIf="menuId != null && menuId != undefined && menuId == 0" class="margin-top-20">
    <app-prospects-list [property]="property" [propertyId]="propertyId" [isFromDashboard]="isFromDashboard" (update)="update($event)"></app-prospects-list>
</ng-container>
<ng-container *ngIf="menuId != null && menuId != undefined && menuId > 0" class="margin-top-20">
    <app-external-marketing-list [property]="property" [isFromDashboard]="isFromDashboard" [propertyId]="propertyId" (update)="update($event)" [externalMarketingType]="externalMarketingType" [externalMarketingId]="menuId"></app-external-marketing-list>
</ng-container>

<ng-template #SalesForceMapper>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Map Salesforce Opportunity</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="form-label">
                SalesForce Opportunity Id
                <!--<span class="star">*</span>-->
            </label>
            <input class="form-control" #SFname="ngModel" maxlength="100" [(ngModel)]="currentSFid" required type="text">
            <!--<p class="redtext" *ngIf="(Validation.IsinValid(property.SFId) && isSubmit) ||(SFname.invalid && SFname.touched)">Salesforce Id is required </p>-->
        </div>
        <div class="text-right">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
            <button class="btn btn-success btn-lg" (click)="openModalForLinking(LinkPortfolio,'deletemodal');">Save</button>
        </div>
    </div>
</ng-template>

<ng-template #LinkPortfolio>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Link Portfolio</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefLinking.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to map this salesforce id ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefLinking.hide()">Cancel</button>
            <button class="btn btn-lg btn-success" (click)="mapSFId();modalRefLinking.hide();">Link</button>
        </div>
    </div>

</ng-template>
